/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bar:hover{fill:#6ab7ff}.title{font-weight:400;font-size:12px;text-transform:uppercase}.xAxisLabels{font-weight:400;font-size:10px}.test{font-size:1.2rem;font-weight:300;margin-bottom:50px;margin-top:50px;text-transform:uppercase;letter-spacing:1px;color:#1e88e5}.swatchCohortCompare{height:15px;width:15px;border-style:solid;border-width:thin;cursor:pointer}"];
export { styles as styles };
